import { render, staticRenderFns } from "./AsignarDocumentoCurso.vue?vue&type=template&id=4583bdbc&scoped=true"
import script from "./AsignarDocumentoCurso.vue?vue&type=script&lang=js"
export * from "./AsignarDocumentoCurso.vue?vue&type=script&lang=js"
import style0 from "./AsignarDocumentoCurso.vue?vue&type=style&index=0&id=4583bdbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4583bdbc",
  null
  
)

export default component.exports